import { useEffect, useState } from 'react';
import { Grid, Link } from '@mui/material';
import { Title } from '../../components/title/title.component';

import "./subscribe-plans.styles.scss";
//import { getMonths } from '../../utils/getData';
import Card from '../../components/card/card.page';
import { getCookie, setCookie, useBreakpoints } from '../../utils/generaFunctions';
import $ from "jquery";

const SubscribePlans = () =>{
    //Query string variables
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gift = urlParams.has('gift') ? urlParams.get('gift') : "";
    const choice_param = urlParams.has('chc') ? urlParams.get('chc') : "";
    const {isXl, isXxl} = useBreakpoints();

    const [choice, setChoice] = useState();
    const [hideShown, setHideShown] = useState(false);
    const [bonusStr, setBonusStr] = useState("");
    const [hide, setHide] = useState(false)
    const [noGreyOut, setNoGreyOut] = useState("");
    const [title] = useState(choice_param==="umbb"?"select by trimester":"best curated option");
    const [subTitle] = useState("");
    const [planTexts, setPlanTexts] = useState([{}]);
    const [ready, setReady] = useState(false);

    const validStrings = [
        "ttm-9mbb-e2m",
        "ttm-8mbb-e2m",
        "ttm-8mbb-e1m",
        "ttm-7mbb-e2m",
        "ttm-7mbb-e1m",
        "ttm-6mbb-e2m",
        "ttm-6mbb-e1m",
        "ttm-5mbb-e1m",
        "ttm-4mbb-e1m",
        "ttm-umbb-e1m",
        "ttm-umbb-e1m2"
    ]

    useEffect(()=>{
        setTimeout(()=>{setReady(true)},300);
       window.dataLayer.push({ ecommerce: null });
        let item_id = gift? "TTM_SUB_BOX_GIFT" : "TTM_SUB_BOX_NON_GIFT";
        let item_name = gift? "TTM Subscription Box - Gift" : "TTM Subscription Box - NonGift";
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "USD",
                value: 35.00,
                items: [
                {
                    item_id: item_id,
                    item_name: item_name,
                    index: 0,
                    price: 35.00,
                    affiliation: "Tum To Mom Box",
                    currency: "USD",
                    quantity: 1
                }
                ]
            }
        });
    },[])
    useEffect(()=>{
        setPlanTexts(planTextSelector(choice_param));
    },[gift, choice_param]);

    useEffect(()=>{
        if(planTexts[0]?.show === true){
            setHide(true);
            // Because of Tilda header
            setTimeout(()=>{setChoice(1);},500);
        }
    },[planTexts]);

    useEffect(()=>{
        if(hideShown){
            document.querySelectorAll(".card.hidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('hidden');
                hiddenCard.classList.add('unhidden');
                setNoGreyOut("yes");
            })
            document.querySelectorAll(".card-box.hidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('hidden');
                hiddenCard.classList.add('unhidden');
            })
        }else {
            document.querySelectorAll(".card.unhidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('unhidden');
                hiddenCard.classList.add('hidden');
                setChoice(1);
            })
            document.querySelectorAll(".card-box.unhidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('unhidden');
                hiddenCard.classList.add('hidden');
            })

        }
    },[hideShown])

    useEffect(()=>{
        setNoGreyOut("");
        var promo = window.sessionStorage.getItem("promo") || getCookie("promo") || urlParams.get("promo");
        var bonus = window.sessionStorage.getItem("bonus") || getCookie("bonus") || urlParams.get("bonus");
        setBonusStr(bonus);
        if(choice>0){
            if(!validStrings.includes(planTexts[choice-1].code) && promo && promo!=="none") {
                $('#t-header').show(); 
                $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF Your First Box On Sign-Up!`);
                setCookie("bonus","");
                window.sessionStorage.setItem("bonus","");
                setBonusStr("");
            } else if(promo && promo!=="none" && bonus) {
                $('#t-header').show();
                setBonusStr(bonus);
                if(bonus.includes("sweatshirt")){
                    $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF First Box + FREE Sweatshirt!`);
                } else if(bonus.includes("pillow")){
                    $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF First Box + FREE Pregnancy Pillow!`);
                }
            } else if(!validStrings.includes(planTexts[choice-1].code)  && (!promo || promo==="none")) {
                $('#t-header').hide();
                setBonusStr("");
            }
            else {
                $('#t-header').show();
                if(bonus) {
                    setBonusStr(bonus);
                }

            }
        }
    },[choice, planTexts, urlParams, validStrings])
    return (
        <Grid container className="subscribe-plans-container" margin="100px 0" justifyContent={"center"}>
            <Grid container item xs={11} justifyContent="center">
                <img src={window.sessionStorage.getItem("promo")||getCookie("promo")||urlParams.get('promo')?require(`../../imgs/box_subs_${window.sessionStorage.getItem("promo")||getCookie("promo")||urlParams.get('promo')}.png`):require('../../imgs/box_subs.png')} alt="box" style={{maxWidth: '149px', width:"100%", marginBottom:"20px"}}></img>
                <img src={require('../../imgs/box_freeshirt.png')} alt="freeshirt" style={{display: bonusStr!=="freemamasweatshirt"?"none":"" ,maxWidth: '128px', width:"100%", margin:"10px 0 0 20px", maxHeight: '128px'}}></img>
                <img src={require('../../imgs/box_freepillow.png')} alt="freepillow" style={{display: bonusStr!=="freepregnancypillow"?"none":"" ,maxWidth: '128px', width:"100%", margin:"10px 0 0 20px", maxHeight: '128px'}}></img>
                <Title title={title} description={subTitle} ></Title>
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} justifyContent="center" flexDirection={{md: hide?"column":"row", sx:"row"}} alignContent="center"  height="fit-content" spacing={(planTexts[0].show !== true)&&(isXl||isXxl)?4:2}>
                {planTexts.map((plan, index) => {
                    return(
                        <Grid key={index+1} className={hide&&index>0?"card-box hidden":"card-box"} item container xs={12} lg={3.5} xl={3} justifyContent={{xs:"center", lg:hide?"center":index===0?"flex-end":index===planTexts.length-1?"flex-start":"center"}} style={{maxWidth:isXl||isXxl?"370px":""}}>
                            <Card className={hide&&index>0?"card hidden":"card"} link="/checkout" plan={plan} onClick={()=>setChoice(index+1)} choice={choice} index={index+1} nogreyout={noGreyOut}></Card>
                        </Grid>
                    )
                })}
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} marginTop="20px" justifyContent="center" className={hide?"":"hidden"}>
                <Link className='text-roman' sx={{borderBottom:'none!important', fontWeight:"400"}} onClick={()=>{setHideShown(!hideShown)}}>{!hideShown?`SHOW ME MORE PLANS >`:`HIDE ADDITIONAL PLANS >`}</Link>
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} marginTop="20px" justifyContent="center">
                <img alt="install" src={require('../../imgs/box_subs_install.png')} width="280px"/>
            </Grid>
        </Grid>
    )

    function planTextSelector(choice_code){
        let returnArr = [];
        if( choice_code === "3mab"){
            returnArr.push({
                title: "NOT AVAILABLE PLAN",
                code: "",
                show: true,
                details: [
                    "Maybe next time!",
                    "Maybe next time!",
                    "Maybe next time!"
                ]
            });
            window.setTextWindow(true, "Oh no!", "Our subscription boxes for this plan have been so popular that they are currently sold out.","go to homepage", "/", false, true);
        } else if(choice_code === "2mbb" || choice_code === "3mbb" || choice_code === "4mbb" || choice_code === "5mbb" || choice_code === "6mbb" || choice_code === "7mbb" || choice_code === "8mbb"){
            let firstText = 'Pregnancy themes, followed by Mom+Baby themes';
            if(choice_code.indexOf("4") >= 0 || choice_code.indexOf("5")>= 0 || choice_code.indexOf("6")>= 0){
                firstText = '2nd & 3rd Trimester themes, then Mom+Baby themes';
            } else if(choice_code.indexOf("2") >= 0 || choice_code.indexOf("3")>= 0){
                firstText = '3rd Trimester themes, followed by Mom+Baby themes';
            }
            returnArr.push({
                title: "MONTHLY PLAN",
                code: `ttm-${choice_code}-e1m`,
                show: true,
                details: [
                    firstText,
                    "Pay and receive boxes once a month",
                    `Automatically stops after the "4th trimester"`
                ]
            });
            returnArr.push({
                title: "EVERY 2 MONTHS PLAN",
                code: `ttm-${choice_code}-e2m`,
                details: [
                    firstText,
                    "Pay and receive a box every 2 months",
                    `Automatically stops after the "4th trimester"`
                ]
            });
        } else if(choice_code === "9mbb"){
            returnArr.push({
                title: "EVERY 2 MONTHS PLAN",
                code: `ttm-${choice_code}-e2m`,
                show: true,
                details: [
                    `Pregnancy themes, followed by mom+baby themes`,
                    "Pay and receive a box every 2 months",
                    `Automatically stops after the "4th trimester"`
                ]
            });
        } else if (choice_code === "1mab" || choice_code === "1mbb"){
            returnArr.push({
                title: "MONTHLY PLAN",
                code: `ttm-${choice_code}-e1m`,
                show: true,
                details: [
                    `Postpartum pampering and Mama+Baby themes`,
                    "Pay and receive boxes once a month",
                    `Automatically stops after 5 themed boxes`
                ]
            });
            returnArr.push({
                title: "EVERY 2 MONTHS PLAN",
                code: `ttm-${choice_code}-e2m`,
                show: true,
                details: [
                    `Postpartum pampering and Mama+Baby themes`,
                    "Pay and receive a box every 2 months",
                    `Automatically stops after 5 themed boxes`
                ]
            });
        } else if (choice_code === "umbb"){
            let secondText = "Pay and receive boxes once a month";
            let lastText = "Automatically stops after the “4th trimester”";
            returnArr.push({
                title: "1st trimester monthly plan",
                code: `ttm-${choice_code}-e1m`,
                details: [
                    `1st to 3rd trimester themes, then Mama+Baby themes`,
                    secondText,
                    lastText
                ]
            });
            returnArr.push({
                title: "2nd trimester monthly plan",
                code: `ttm-${choice_code}-e1m2`,
                details: [
                    `From 2nd trimester themes, then Mama+Baby themes`,
                    secondText,
                    lastText
                ]
            });
            returnArr.push({
                title: "3rd trimester monthly plan",
                code: `ttm-${choice_code}-e1m3`,
                details: [
                    "From 3rd trimester themes, then Mama+Baby themes",
                    secondText,
                    lastText
                ]
            });
        }
        if(choice_code === "2mbb" || choice_code === "3mbb" || choice_code === "4mbb" || choice_code === "5mbb" || choice_code === "6mbb" || choice_code === "7mbb" || choice_code === "8mbb" || choice_code === "9mbb"){
            const mom_baby = choice_code === "2mbb"? 2:1;
            returnArr.push({
                title: "INTRO MONTHLY PLAN",
                code: `ttm-${choice_code}-e1mi`,
                details: [
                    `${choice_code === "2mbb"||choice_code === "3mbb"? (4-mom_baby)+" pregnancy themes, " + mom_baby + " mom+baby themes":
                    ((choice_code === "4mbb"?"":"First ") + "4 pregnancy themes, option to extend")}`,
                    "Pay and receive boxes once a month",
                    "Automatically stops after the 4th box, if not extended"
                ]
            });
        }
        return returnArr;
    }
}

export default SubscribePlans;